import { Injectable } from "@angular/core";
import { BusinessUnitDto } from "@sharedcommon/model/organization/business-unit.model";
import { BusinessUnitFilterDto } from "@sharedcommon/model/organization/filter/business-unit-filter.model";
import { SharedPagedResponse } from "@sharedcommon/model/shared-paged-response.model";
import { NeqHttpClient } from "@sharedcommon/rest/http-client.config";
import { OrganizationApiUrlUtil } from "@sharedcommon/util/organization-api-url.util";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class BusinessUnitRestService {

  constructor(protected neqHttpClient: NeqHttpClient) {}
  
  /**
   * Get business unit by code
   * Response code 200 - Found business unit
   * Response code 404 - Not found business unit
   * Response code 500 - Error
   * HTTP GET /business-unit/{code}
   * Java method: com.neovia.services.organization.controller.BusinessUnitController.getByCode()
   */
  getByCode(code: string): Observable<BusinessUnitDto> {
    return this.neqHttpClient.request({ method: 'GET', url: OrganizationApiUrlUtil.formatApiUrl(`business-unit/${code}`) });
  }
  
  /**
   * Search business units
   * Response code 200 - paged response of business unit
   * Response code 500 - Error
   * HTTP GET /business-unit/search
   * Java method: com.neovia.services.organization.controller.BusinessUnitController.search()
   */
  search(filterDto: BusinessUnitFilterDto): Observable<SharedPagedResponse<BusinessUnitDto>> {
    return this.neqHttpClient.request({ method: 'GET', url: OrganizationApiUrlUtil.formatApiUrl("business-unit/search"), data: filterDto });
  }
  
  /**
   * Search business units by entity code
   * Response code 200 - paged response of business unit
   * Response code 500 - Error
   * HTTP GET entity/{entityCode}/business-unit/search
   * Java method: com.neovia.services.organization.controller.EntityController.searchBusinessUnitsByEntityCode()
   */
  searchByEntityCode(entityCode: string, filterDto: BusinessUnitFilterDto): Observable<SharedPagedResponse<BusinessUnitDto>> {
    return this.neqHttpClient.request({ method: 'GET', url: OrganizationApiUrlUtil.formatApiUrl(`entity/${entityCode}/business-unit/search`), data: filterDto });
  }
}